import { UnprocessableContentErrorDialog } from "./422";
import { InternalServerErrorDialog } from "./500";
import { BadGatewayErrorDialog } from "./502";
import { BadRequestErrorDialog } from "./400";
import { AuthErrorDialog } from "./401";

// import { getErrorMessage, getStatusCode } from "../../../lib/helper";
// import { MESSAGES, STATUS } from "../../../configs/error";

interface ErrorDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  error: any;
  setError: (error: any) => void;
}

export function ErrorDialog({
  open,
  onOpenChange,
  error,
  setError,
}: ErrorDialogProps) {
  if (!error?.id) return null;

  let { id, status, type } = {
    id: error?.id,
    status: error?.response?.status,
    type: error?.response?.data?.detail,
  };

  // const status = getStatusCode({ config: STATUS, type });

  if (id === "dashboard" && type === "User Count Not Enough Error") {
    status = 400;
  }

  if (status === 401) {
    return (
      <AuthErrorDialog
        open={open}
        onOpenChange={onOpenChange}
        error={error}
        setError={setError}
      />
    );
  } else if (status === 400) {
    return (
      <BadRequestErrorDialog
        open={open}
        onOpenChange={onOpenChange}
        error={error}
        setError={setError}
      />
    );
  } else if (status === 422) {
    return (
      <UnprocessableContentErrorDialog
        open={open}
        onOpenChange={onOpenChange}
        error={error}
        setError={setError}
      />
    );
  } else if (status === 500) {
    return (
      <InternalServerErrorDialog
        open={open}
        onOpenChange={onOpenChange}
        error={error}
        setError={setError}
      />
    );
  } else if (status === 502) {
    return (
      <BadGatewayErrorDialog
        open={open}
        onOpenChange={onOpenChange}
        error={error}
        setError={setError}
      />
    );
  } else {
    return null;
  }
}
